import Engine from "../utilities/engine";
import CartAttributesRule from "./cart.attributes";
import CartIncludesRule from "./cart.includes";
import CartTotalRule from "./cart.total";
import CustomerTagsRule from "./customer.tags";
import ProductTagsRule from "./product.tags";

class RulesEngine extends Engine {
  name = "RulesEngine";

  constructor() {
    super();
  }

  /**
   * Evaluate the rules of this engine and evaluate them against the data.
   * 
   * @param {Object} data 
   * @returns {Promise<boolean>}
   */
  async evaluate(data) {
    let result = true;
    for await (const component of this.components) {
      // result &&= is a short-circuiting operation. The &&= operator checks the
      // value of result before evaluating the right-hand side. If result is 
      // false, it skips the right-hand side entirely, so the await may not be 
      // hit at all.
      let componentResult = await component.evaluate(data);
      result &&= componentResult;
    }
    return result;
  }

  /**
   * Describe the engine in the console.
   */
  async explain() {
    console.group("🤔 If...");
    for await (const component of this.components) {
      let explanation = await component.explain();
      console.log(`• ${explanation}`);
    }
    console.groupEnd();
  }

  /**
   * Static method to create a rule from a JS object or JSON string. Needs to be
   * here (rather than in the Rule class) to avoid circular dependencies.
   */
  static fromJSON(json) {
    if (typeof json === 'string') {
      json = JSON.parse(json);
    }
    switch(json.type) {
      case "cart.total":
        return new CartTotalRule(json.config);
      case "cart.includes":
        return new CartIncludesRule(json.config);
      case "cart.attributes":
        return new CartAttributesRule(json.config);
      case "product.tags":
        return new ProductTagsRule(json.config);
      case "customer.tags":
        return new CustomerTagsRule(json.config);
    }

    throw new Error(`[R-E] Unknown rule type: ${json.type}`);
  }
}

export default RulesEngine;